// extracted by mini-css-extract-plugin
export default {"partnerTitle":"PartnerDetail_partnerTitle__U-U76"};